import * as React from "react"

const Download = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M7.5 8.8 5.85 7.14l-.35-.36-.7.71.35.35 2.5 2.5.35.36.35-.36 2.5-2.5.36-.35-.71-.7-.35.35L8.5 8.79V2.5h-1v6.3Zm5.5 4.7H3v-1h10v1Z" />
  </svg>
)

export default Download
